var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { connectScript } from "@/tools/scriptTools";
import { buildUrl } from "@/tools/utils/fetchUrl";
var YANDEX_MAPS_API_KEY = "1254ae24-4f80-4784-9792-c3d1870cd4f4";
var getPoint = function (query) { return __awaiter(void 0, void 0, void 0, function () {
    var geocoderUrl, result, geoPoint, pos, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                geocoderUrl = buildUrl("https://geocode-maps.yandex.ru/1.x/", {
                    apikey: YANDEX_MAPS_API_KEY,
                    geocode: query,
                    format: "json",
                });
                return [4 /*yield*/, fetch(geocoderUrl)];
            case 1: return [4 /*yield*/, (_b.sent()).json()];
            case 2:
                result = _b.sent();
                geoPoint = result.response.GeoObjectCollection.featureMember[0].GeoObject;
                pos = geoPoint.Point.pos.split(" ");
                return [2 /*return*/, pos.map(Number).reverse()];
            case 3:
                _a = _b.sent();
                throw new Error("Невозможно получить координаты");
            case 4: return [2 /*return*/];
        }
    });
}); };
var setMapPoint = function (map, position, onChange) {
    var placemark = new window.ymaps.GeoObject({
        geometry: {
            type: "Point",
            // @ts-expect-error ts(2322)
            coordinates: position,
        },
    }, {
        preset: "islands#icon",
        iconColor: "#ff0000",
        draggable: true,
    });
    map.geoObjects.add(placemark);
    placemark.events.add("dragend", function () {
        // @ts-expect-error ts(2339)
        var coords = placemark.geometry.getCoordinates();
        onChange({ latitude: coords[0], longitude: coords[1] });
    });
    return placemark;
};
/** Редактирование гео-точки с расположением площадки */
export var EditMap = function (props) {
    var mapRef = useRef(null);
    var mapIsInit = useRef(false);
    var initMap = function () {
        // Проверяем, что карта ещё не инициализирована
        if (mapIsInit.current)
            return;
        mapIsInit.current = true;
        if (!mapRef.current || !window.ymaps)
            return;
        window.ymaps.ready(function () { return __awaiter(void 0, void 0, void 0, function () {
            var position, map, placemark_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        position = props.point && [
                            props.point.latitude,
                            props.point.longitude,
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!!position) return [3 /*break*/, 3];
                        return [4 /*yield*/, getPoint(props.city || "")];
                    case 2:
                        position = _a.sent();
                        _a.label = 3;
                    case 3:
                        map = new window.ymaps.Map(mapRef.current, {
                            center: position,
                            zoom: 16,
                            controls: ["zoomControl"],
                        }, {
                            maxZoom: 16,
                        });
                        placemark_1 = setMapPoint(map, position, props.onChange);
                        map.events.add("click", function (e) {
                            var coords = e.get("coords");
                            // @ts-expect-error ts(2339)
                            placemark_1.geometry.setCoordinates(coords);
                            props.onChange({ latitude: coords[0], longitude: coords[1] });
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
    };
    useEffect(function () {
        if (window.ymaps) {
            initMap();
            return;
        }
        connectScript({
            src: "https://api-maps.yandex.ru/2.1/?apikey=".concat(YANDEX_MAPS_API_KEY, "&lang=ru_RU"),
            id: "yandex-map-script",
            onload: initMap,
        });
    }, []);
    return _jsx("div", { ref: mapRef, style: { width: "100%", height: 300 } });
};
